import { DocViewerRenderers } from "@cyntler/react-doc-viewer";
import { faDownload } from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Button, Grid, UploadFile } from "antd";
import { useIntl } from "react-intl";
import * as Styled from "../styled";

interface IInitiativePreviewModalProps {
  open: boolean;
  cdnFilePath: string;
  previewFile: UploadFile[];
  onCancel: () => void;
  onDownload: (filePath: string) => void;
}

export const InitiativePreviewModal = ({
  open,
  cdnFilePath,
  previewFile,
  onCancel,
  onDownload,
}: IInitiativePreviewModalProps): React.JSX.Element => {
  const intl = useIntl();
  const screens = Grid.useBreakpoint();

  return (
    <Styled.PreviewDrawer
      open={open}
      onClose={onCancel}
      width={screens.md ? "95vw" : "100vw"}
      title={previewFile?.[0]?.name}
      extra={
        <Button
          type="primary"
          icon={<FontAwesomeIcon icon={faDownload} />}
          onClick={() => onDownload(cdnFilePath)}
        >
          {intl.formatMessage({ id: "general.download" })}
        </Button>
      }
    >
      <Styled.PreviewDocViewer
        documents={previewFile?.map((file) => ({
          uri: cdnFilePath,
          fileName: file.name,
        }))}
        pluginRenderers={DocViewerRenderers}
        config={{ header: { disableHeader: false }, pdfZoom: { defaultZoom: 1, zoomJump: 0.1 } }}
      />
    </Styled.PreviewDrawer>
  );
};

export default InitiativePreviewModal;
